// FORM CONTROLS
// ===================================================

var form_controls = {

    settings: {
        required: $('form'),
        form_inputs: $('.gfield--type-email input, .gfield--type-phone input, .gfield--type-select select, .gfield--type-text input, .gfield--type-textarea textarea, .ginput_container_date input'),
        slide_in_form: $('.slide-in-form'),
        states_dropdown: $('form.search-by-state'),
    },

    init: function () {
        // General form functions
        if (this.settings.required.length) {
            form_controls.bindUIActions();
            form_controls.initializeLabels();
        }
        // Slide-in form
        if (this.settings.slide_in_form.length) {
            form_controls.slideInForm();
        }
        // Search by state form
        if (this.settings.states_dropdown.length) {
            form_controls.statesDropdown();
        }
    },

    bindUIActions: function () {
        // Activate rows on click
        this.settings.form_inputs.on('blur', form_controls.toggleLabels);
        this.settings.form_inputs.on('focus', form_controls.toggleLabels);
    },

    // On page load activate labels that have a value in them
    initializeLabels: function () {
        this.settings.form_inputs.each(function () {
            if ($(this).val().length) {
                $(this).closest('.gfield').addClass('has-value');
            }
        });
    },

    // Slide-in form
    slideInForm: function() {
        // Open form on linked button clicks
        $('.js-open-slide-in-form').on('click', function(e) {
            e.preventDefault();
            form_controls.settings.slide_in_form.addClass('open');
            $('body').addClass('no-scroll');
        });
        // Close form
        $('.js-close-slide-in-form').on('click', function() {
            form_controls.settings.slide_in_form.removeClass('open');
            $('body').removeClass('no-scroll');
        });
    },

    // Go to the selected state from the states dropdown form
    statesDropdown: function() {
        form_controls.settings.states_dropdown.on('submit', function(e) {
            e.preventDefault();
            window.location.href = $(this).find('[id*=search-state]').val();
        });
    },

    // Toggle label positioning
    toggleLabels: function(e) {
        // Check for empty inputs and deactivate labels on blur
        if (e.type == 'blur') {
            $(this).closest('.gfield').removeClass('active');
            // If a value is present
            if ($(this).val().length) {
                $(this).closest('.gfield').addClass('has-value');
            } else {
                $(this).closest('.gfield').removeClass('has-value');
            }
        } else {
            $(this).closest('.gfield').addClass('active');
        }
    },

};
form_controls.init();


// GRAVITY FORMS - STEPPED FORM CONTROLS
// ===================================================

// Rebind events on AJAX step changes for AJAX stepped forms with floated labels
$(document).on('gform_post_render', function() {

    var gf_controls = {

        settings: {
            required: $('form'),
            form_inputs: $('.gfield--type-email input, .gfield--type-phone input, .gfield--type-select select, .gfield--type-text input, .gfield--type-textarea textarea, .ginput_container_date input'),
            custom_radio_buttons: $('.gfield--type-radio.style-button .gchoice input'),
        },
    
        init: function () {
            // General form functions
            if (this.settings.required.length) {
                gf_controls.bindUIActions();
                gf_controls.initializeLabels();
            }
            // Custon Radio Buttons
            if (this.settings.custom_radio_buttons.length) {
                gf_controls.customRadioButtons();
            }
        },
    
        bindUIActions: function () {
            // Activate rows on click
            this.settings.form_inputs.on('blur', gf_controls.toggleLabels);
            this.settings.form_inputs.on('focus', gf_controls.toggleLabels);
            this.settings.form_inputs.on('input', gf_controls.toggleLabels);
        },

        // Custom Radio Buttons
        customRadioButtons: function() {
            // Initialize selected option
            this.settings.custom_radio_buttons.closest('.gfield_radio').find('.gchoice input:checked').closest('.gchoice').addClass('selected');
            // Update selection style
            this.settings.custom_radio_buttons.on('change', function() {
                // Clear all selections
                $(this).closest('.gfield_radio').find('.gchoice').removeClass('selected');
                // Activate current seleciton
                $(this).closest('.gchoice').addClass('selected');
            });
        },
    
        // On page load activate labels that have a value in them
        initializeLabels: function () {
            gf_controls.settings.form_inputs.each(function() {
                if ($(this).val().length) {
                    $(this).closest('.gfield').addClass('has-value');
                }
            });
            setTimeout(() => {
                gf_controls.settings.form_inputs.each(function() {
                    if ($(this).val().length) {
                        $(this).closest('.gfield').addClass('has-value');
                    }
                });
            }, 2000);
        },
    
        // Toggle label positioning
        toggleLabels: function(e) {
            // Check for empty inputs and deactivate labels on blur
            if (e.type == 'blur') {
                $(this).closest('.gfield').removeClass('active');
                // If a value is present
                if ($(this).val().length) {
                    $(this).closest('.gfield').addClass('has-value');
                } else {
                    $(this).closest('.gfield').removeClass('has-value');
                }
            } else {
                $(this).closest('.gfield').addClass('active');
            }
        },
    
    };
    gf_controls.init();

});